module.exports = __webpack_public_path__ + "static/img/liuhuapeng.2040920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teacher/liuhuapeng.png
// module id = xxhW
// module chunks = 2